import {Request} from '@simpli/serialized-request'

export class RecoverPasswordByMailRequest {
  email: string | null = null

  /**
   * Sends an email requesting to change the password
   */
  async recoverPasswordByMail() {
    return await Request.put(`/client/auth/password`, this)
      .name('recoverPasswordByMail')
      .asNumber()
      .getData()
  }
}
